import directionStraight from '@iconify/icons-carbon/arrow-up';
import { Fab, useScrollTrigger, Zoom } from '@mui/material';
import { Box } from '@mui/system';
import { Iconify } from '.';

function ScrollTop() {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = ((event.target as HTMLDivElement).ownerDocument || document).querySelector(
      '#back-to-top-anchor'
    );

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 20, left: 20 }}
      >
        <Fab color="default" size="small" aria-label="scroll back to top">
          <Iconify icon={directionStraight} sx={{ width: 20, height: 20 }} />
        </Fab>
      </Box>
    </Zoom>
  );
}

export default ScrollTop;
